/* eslint-disable @typescript-eslint/no-explicit-any */
import {errorAtom} from '@state'

import {useEffect} from 'react'

import {useQueryClient} from '@tanstack/react-query'
import {useSetAtom} from 'jotai'

export function useReactQueryErrorBridge() {
  const queryClient = useQueryClient()
  const setError = useSetAtom(errorAtom)

  useEffect(() => {
    const wrapError = (rawError: unknown): Error => {
      const axiosError = rawError as any
      const message = axiosError?.response?.data?.message || axiosError?.message || 'Unknown error'
      const e = new Error(message)
      ;(e as any).status = axiosError?.response?.status
      return e
    }

    // Track which errors we already fired to prevent duplicates
    const firedErrors = new WeakSet<any>()

    // Handle errors for queries and mutations
    const handleError = (error: unknown) => {
      if (!error || firedErrors.has(error)) return
      firedErrors.add(error)
      setError(wrapError(error))
      console.error('[React Query Global Error]', error)
    }

    // Subscribe to query cache
    const unsubscribeQueries = queryClient.getQueryCache().subscribe(event => {
      const error = event.query?.state.error
      if (error) handleError(error)
    })

    // Subscribe to mutation cache
    const unsubscribeMutations = queryClient.getMutationCache().subscribe(event => {
      const error = event.mutation?.state.error
      if (error) handleError(error)
    })

    return () => {
      unsubscribeQueries()
      unsubscribeMutations()
    }
  }, [queryClient, setError])
}
